import { compact } from 'lodash'

export const optionalConcat = (elements: unknown[], joinChar = ', ') => {
  return elements ? compact(elements).join(joinChar) : ''
}
